import React, { useEffect, useRef, useState } from 'react'
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfTemplate from './PdfTemplate';
import { useContext } from 'react';
import { simulatorContext } from '../../service/SimulatorContext';
import { appContext } from '../../service/AppContext';

export default function ExportPdf() {
    const { user } = useContext(appContext);
    const { setUserNamePopup } = useContext(simulatorContext);

    const [downloadPdf, setDownloadPdf] = useState(false);

    return (

        <div className="pdf-wrapper align-center"  >
            {
                (user.firstName || user.lastName) ?
                    <span onClick={() => { setDownloadPdf(true) }}><img src="./icons/pdf.svg" alt="pdf" style={{ margin: "4px" }} />יצוא ל-PDF</span>
                    :
                    <span onClick={() => { setUserNamePopup(true) }}>
                        <img src="./icons/pdf.svg" alt="pdf" style={{ margin: "4px" }} />יצוא ל-PDF
                    </span>
            }
            <div style={{ display: "none" }}>
                {(downloadPdf) && <CreateLinkAndClick postClickCallback={() => { setDownloadPdf(false) }} />}
            </div>
        </div>
    )
}


export function CreateLinkAndClick({ postClickCallback }) {
    const { completedKids, summaryKids } = useContext(simulatorContext);
    const { user } = useContext(appContext);

    const linkRef = useRef();

    useEffect(() => {
        let timeout;
        if (linkRef.current) {
            timeout = setTimeout(() => {
                linkRef.current?.click();
                if (postClickCallback && typeof (postClickCallback === 'function'))
                    postClickCallback();
            }, 800);
        }
        return () => { if (timeout) clearTimeout(timeout) }
    })


    return (
        <PDFDownloadLink document={<PdfTemplate user={user} completedKids={completedKids} summaryKids={summaryKids} />} fileName="סימולטור_תרומות_והלוואות.pdf">
            <span ref={linkRef} ></span>
        </PDFDownloadLink >
    )
}